import { API_BASE_URL } from './api';

const authHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export type NotificationType =
  | 'BuddyRequest'
  | 'BuddyAccepted'
  | 'BuddyActivity'
  | 'EquipmentService'
  | 'DiveShared'
  | 'DiveShareAccepted'
  | 'NewFollower'
  | 'PostTagged'
  | 'PostCommented'
  | 'PostReacted'
  | 'GroupInvite'
  | 'GroupJoinRequest'
  | 'GroupJoinApproved'
  | 'GroupRoleChanged'
  | 'CommentTagged'
  | 'GroupTagged'
  | 'ClubInvite'
  | 'ClubJoinRequest'
  | 'ClubJoinApproved'
  | 'ClubRoleChanged'
  | 'ClubTagged'
  | 'NereusReplied'
  | 'NereusReplyUnavailable'
  | 'OpenDiveJoined'
  | 'DiveAnniversary'
  | 'PostShared'
  | 'NewMessage'
  | 'InviteAccepted'
  | 'ReportFiled'
  | 'ModerationNotice';

export interface AppNotification {
  notificationId: string;
  userId: string;
  type: NotificationType;
  title: string;
  body: string;
  relatedEntityId?: string;
  read: boolean;
  createdAt: string;
  /** Whose action caused this (reactor, commenter, follower, sender). Older rows have none. */
  actorUserId?: string | null;
  actorDisplayName?: string | null;
  actorProfilePhotoUrl?: string | null;
}

export const notificationService = {
  getNotifications: async (userId: string, limit = 50): Promise<AppNotification[]> => {
    const res = await fetch(`${API_BASE_URL}/notifications/${userId}?limit=${limit}`, {
      headers: authHeaders(),
    });
    if (!res.ok) throw new Error('Failed to load notifications');
    return res.json();
  },

  markRead: async (userId: string, notificationId: string): Promise<void> => {
    await fetch(`${API_BASE_URL}/notifications/${notificationId}/read?userId=${encodeURIComponent(userId)}`, {
      method: 'POST',
      headers: authHeaders(),
    });
  },

  markAllRead: async (userId: string): Promise<void> => {
    await fetch(`${API_BASE_URL}/notifications/read-all?userId=${encodeURIComponent(userId)}`, {
      method: 'POST',
      headers: authHeaders(),
    });
  },

  dismiss: async (userId: string, notificationId: string): Promise<void> => {
    await fetch(`${API_BASE_URL}/notifications/${notificationId}?userId=${encodeURIComponent(userId)}`, {
      method: 'DELETE',
      headers: authHeaders(),
    });
  },
};
